import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import '../../../assets/scss/resumopf.scss';
import configBase from '../../../configBase';
import axios from 'axios';
import InputMask from 'react-input-mask';
import DateFnsUtils from '@date-io/date-fns';
import ptBRLocale from "date-fns/locale/pt-BR";
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import {DropzoneDialog} from 'material-ui-dropzone';
import ReactToPrint from 'react-to-print';
import PrintIcon from '@material-ui/icons/Print';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import SendIcon from '@material-ui/icons/Send';
import CancelScheduleSendIcon from '@material-ui/icons/CancelScheduleSend';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

import {
  ScrollableTabsButtonAuto
} from './components';



class ResumoProposta extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      imprimir: true,
      page: '',
      titlePage: '',
      apiPage: null,
      detailsData: 'loading',
      detailsDataLoadingMsg: 'VALIDANDO A PROPOSTA...',

      stateList: [],
      addressTypeList: [],
      cityList: [],
      districtList: [],
      pendencyList: [],
      cardFlagList: [],

      modalConfirmOpen: false,
      modalConfirmLoading: false,
      cancellationsList: [],
      modalConfirmQuestionContent: '',
      modalConfirmActionType: '',
      modalConfirmButton: '',
      modalConfirmButtonLoading: false,
      modalConfirmQuestion: false,
      fieldCancel: 'null',
      fieldPending: 'null',

      currentTimeServer: null,
      listYear: [],
      errorRequest: false,
      msgErrorRequest: '',
      snackbarSuccess: false,
      msgSnackbarSuccess: '',

      showFirstPayment: false,
      disabledInput: true,
      disabledInputValuePlan: true,
      disabledInputHolder: true,

      disabledLoadingAddressType: false,
      disabledLoadingAddressNumber: false,
      disabledLoadingAddress: false,
      disabledLoadingAddressComplement: false,
      disabledLoadingState: false,
      disabledLoadingCity: false,
      disabledLoadingDistrict: false,

      fMCity: '',
      fMDistrict: '',

      showActionS4: false,
      showActionSendAfterSales: false,
      showActionPendency: false,
      showActionPendencyField: false,
      showActionCancel: false,
      showActionCancelField: false,
      showActionSendAnalyze: false,

      showFileAverbation: false,

      confirm: false,
      confirmCheck: false,
      errorCheck: false,

      dropzoneDialog: false,
      typeFile: '',

      fullScreenModal: false,

      confirmFmMensage: '',

      disabledCardHolderName: true,
      disabledCardNumber: true,
      disabledCardValidity: true,

      planCredtCard: false,

      vencBoleto: '',

      msgSus: 'Caso a proposta esteja revisada, aprovada e pronta para ser efetivada, clique no botão ATIVAR.',
      msgFileAverbation: '',
      msgContinue: false,

      showMatricula: false,
      showAdmissionDate: false,

      showLoadindDowloadPdf: false,
    };

    this.parentageList = {
      "CÔNJUGE/COMPANHEIRO": 3,
      "CONJUGE/COMPANHEIRO": 3,
      "COMPANHEIRO": 3,
      "CONJUGE": 3,
      "CÔNJUGE": 3,
      "FILHO": 4,
      "PAI/MÃE": 8,
      "PAI/MAE": 8,
      "OUTRO": 10,
      "AGREGADO": 10,
      "ENTEADO": 6,
    };

  }


  componentDidMount() {
    this.beforeDetails();
    this.fullScreenModalFn();
  }

  dateOfBirthInverter() {
    let dn = this.state.detailsData.financialManager.dateOfBirth.split('-');
    dn = dn[2] + '-' + dn[1] + '-' + dn[0]
    return dn
  }

  stateToResume() {
    for (let i = 0; i < this.state.stateList.length; i++) {
      if (this.state.detailsData.financialManager.state.toString() === this.state.stateList[i].Id.toString()) {
        return this.state.stateList[i].Sigla;
      }
    }
  }

  cityToResume()  {
    for (let i = 0; i < this.state.cityList.length; i++) {
      if (this.state.detailsData.financialManager.city.toString() === this.state.cityList[i].Id.toString()) {
        return this.state.cityList[i].Nome;
      }
    }
  }

  districtToResume()  {
    for (let i = 0; i < this.state.districtList.length; i++) {
      if (this.state.detailsData.financialManager.district.toString() === this.state.districtList[i].Id.toString()) {
        return this.state.districtList[i].Nome;
      }
    }
  }

  formatePlanoDental () {
    let state = this.state

    let total = state.detailsData.financialManager.responsibility.replace(',', '.')
    total = parseFloat(total)

    let taxaImplementacao = state.detailsData.plan.taxaImplantacao.replace(',', '.')
    taxaImplementacao = parseFloat(taxaImplementacao)

    let valorRetornado = total - taxaImplementacao

    valorRetornado = valorRetornado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    valorRetornado = valorRetornado.toString()
    valorRetornado = valorRetornado.replace('.', ',')

    return valorRetornado
  }

  formateTotal () {
    let total = this.state.detailsData.financialManager.responsibility.replace(',', '.')
    total = parseFloat(total)
    total = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    total = total.toString()
    total = total.replace('.', ',')
    
    return total
  }

  formateTaxaImplementacao () {
    let taxaImplementacao = this.state.detailsData.plan.taxaImplantacao.replace(',', '.')
    taxaImplementacao = parseFloat(taxaImplementacao)
    taxaImplementacao = taxaImplementacao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    taxaImplementacao = taxaImplementacao.toString()
    taxaImplementacao = taxaImplementacao.replace('.', ',')
    
    return taxaImplementacao
  }

  formatacaoData () {
    if (this.state.detailsData.sales.fMConfirm) {
      let dataBanco = this.state.detailsData.sales.fMConfirm.substr(0, 10).split('-')
      let horaBanco = this.state.detailsData.sales.fMConfirm.substr(11, 8)

      let dataEHora = dataBanco[2] + '/' + dataBanco[1] + '/' + dataBanco[0] + ' ' + horaBanco

      return dataEHora
    }
    else
      return '';
  }

  fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960)
      state.fullScreenModal = false;
    else
      state.fullScreenModal = true;

    this.setState(state);
  }

  beforeDetails() {
    let state = this.state;
    let salesId = this.props.history.location.search.replace('?p=', '');

    if (salesId && salesId.length > 0) {
      let url = configBase.api + 'Sales/count?where={"id":"'+salesId+'"}&access_token='+localStorage.getItem('planos_t');

      axios.get(url)
      .then((response) => {
        state.detailsDataLoadingMsg = 'BUSCANDO LISTA DE TIPOS DE LOGRADOUROS...';
        this.setState(state);

        // Caso encontre a proposta
        if (response.data.count > 0) {




          axios.get(configBase.api + 'APIS4s/tipoLogradouro?access_token='+localStorage.getItem('planos_t'))
          .then((result) => {
            let state = this.state;
            state.detailsDataLoadingMsg = 'BUSCANDO LISTA DE ESTADOS...';
            state.addressTypeList = result.data; // Tipo logradouro
            this.setState(state);

            // Pega a lista de estados
            axios.get(configBase.api + 'APIS4s/UFs?access_token='+localStorage.getItem('planos_t'))
            .then((result) => {
              // Estados
              state.stateList = result.data;
              state.detailsDataLoadingMsg = 'BUSCANDO LISTA DE PENDENCIAS...';
              this.setState(state);



              // Pega a lista de pendências
              axios.get(configBase.api + 'Pendencies?access_token='+localStorage.getItem('planos_t'))
              .then((result) => {
                // Pendências
                state.pendencyList = result.data;
                state.detailsDataLoadingMsg = 'BUSCANDO LISTA DE CANCELAMENTOS...';
                this.setState(state);

                // Pega a lista de cancelamentos
                axios.get(configBase.api + 'Cancellations?filter={"order":"code ASC"}&access_token='+localStorage.getItem('planos_t'))
                .then((result) => {
                  let cancellationsList = [];

                  for (let i = 0; i < result.data.length; i++) {
                    if (result.data[i].clientDefault !== true)
                      cancellationsList.push(result.data[i]);
                  }

                  // Cancelamentos
                  state.cancellationsList = cancellationsList;
                  state.detailsDataLoadingMsg = 'VERIFICANDO DATA E HORA ATUAL...';
                  this.setState(state);

                  // Pega a data atual do servidor
                  axios.post(configBase.api + 'Sales/currentTime?access_token='+localStorage.getItem('planos_t'))
                  .then((response) => {
                    // Hora atual do servidor
                    state.currentTimeServer = response.data;
                    state.detailsDataLoadingMsg = 'BUSCANDO LISTA DE BANDEIRAS...';

                    // Pega as bandeiras do cartão de crédito
                    axios.get(configBase.api + 'CardFlags?filter={"where":{"type":"C"}}&access_token='+localStorage.getItem('planos_t'))
                    .then((response) => {
                      // Hora atual do servidor
                      state.cardFlagList = response.data;
                      state.detailsDataLoadingMsg = 'BUSCANDO DADOS DA PROPOSTA...';

                      this.getDetails(salesId);
                      this.setState(state);

                    })
                    .catch(function () {
                      this.setError('Problema encontrado ao verificar a data e hora atual', 'error');
                    }.bind(this));
                  })
                  .catch(function () {
                    this.setError('Problema encontrado ao verificar a data e hora atual', 'error');
                  }.bind(this));
                })
                .catch(function () {
                  this.setError('Problema encontrado ao buscar a lista de Cancelamentos', 'error');
                }.bind(this));
              })
              .catch(function () {
                this.setError('Problema encontrado ao buscar a lista de Pendências', 'error');
              }.bind(this));




            })
            .catch(function () {
              this.setError('Problema encontrado ao buscar a lista dos estados', 'error');
            }.bind(this));
          })
          .catch(function () {
            this.setError('Problema encontrado ao buscar a lista dos tipos de logradouro', 'error');
          }.bind(this));




        }
        else {
          let state = this.state;
          state.detailsData = 'zero';
          this.setState(state);
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar dados da proposta', 'error');
      }.bind(this));
    }
    else {
      state.titlePage = '';
      this.setError('A proposta é obrigatória', 'error');
    }

    this.setState(state);
  }

  getDetails(salesId) {
    let dataPost = {
      salesId: salesId
    };

    let url = configBase.api + 'Sales/getProposalDetails?access_token='+localStorage.getItem('planos_t');

    axios.post(url, dataPost)
    .then((response) => {
      let userType = localStorage.getItem('planos_y');
      let state = this.state;
      state.titlePage = ' - '+response.data.financialManager.proposalNumber;
      state.detailsData = response.data;

      // Verifica se o plano é do tipo cartão de crédito
      if (response.data.financialManager.formOfPayment === 'CARTAO' || response.data.financialManager.formOfPayment === 'CARTÃO')
        state.planCredtCard = true;

      if (userType === 'SALESMAN') {
        // Permite edição de campos do resumo da proposta
        state.disabledInput = false;
        state.disabledInputValuePlan = true;
      }

      // Verifica exibição de primeiro pagamento
      if (userType === 'REGISTER' || userType === 'AFTER SALES') {
        state.showFirstPayment = true;
        // Permite edição de campos do resumo da proposta
        state.disabledInput = false;
        state.disabledInputValuePlan = false;
      }

      // Lista com os anos para exibir no select
      state.listYear = [];
      state.listYear.push(response.data.currentTime.year - 2);
      state.listYear.push(response.data.currentTime.year - 1);
      state.listYear.push(response.data.currentTime.year);
      state.listYear.push(response.data.currentTime.year + 1);
      state.listYear.push(response.data.currentTime.year + 2);

      // Para exibir ou não o botão de confirmação
      if (response.data.sales.status === "PAGAMENTO PENDENTE" && response.data.sales.salesmanConfirm === null)
        state.confirm = false;
      else
        state.confirm = true;

      // Verifica edição de campos do titular
      if (response.data.financialManager.cpf === response.data.holder.cpf)
        state.disabledInputHolder = true;
      else
        state.disabledInputHolder = false;

      // Caso o responsável financeiro ainda não tiver confirmado
      if (response.data.sales.fMConfirm === null)
        state.confirmFmMensage = 'O cliente ainda não realizou a confirmação. Por favor aguarde.';

      if (state.detailsData.financialManager.formOfPayment === 'BOLETO' && state.detailsData.financialManager.vencimentoBoleto) {
        let vencimentoBoleto = new Date(state.detailsData.financialManager.vencimentoBoleto);
        let day = vencimentoBoleto.getDate();
        let month = vencimentoBoleto.getMonth() + 1;
        let year = vencimentoBoleto.getFullYear();

        if (day < 10)
          day = '0'+day;

        if (month < 10)
          month = '0'+month;

        state.vencBoleto = day+'-'+month+'-'+year;
      }

      if (state.detailsData.financialManager.TypeFm === "SERVIDOR") {
        state.showMatricula = true;
      }

      if (state.detailsData.financialManager.TypeFm === "FUNCIONARIO") {
        state.showMatricula = true;
        state.showAdmissionDate = true;

        if (state.detailsData.financialManager.admissionDate) {
          let admissionDate = state.detailsData.financialManager.admissionDate.split('/');
          state.detailsData.financialManager.admissionDate = admissionDate[2]+'-'+admissionDate[1]+'-'+admissionDate[0];
        }
      }

      this.setState(state);
      // Exibe ou não o campo de ação
      this.rulesOfActions(response.data.sales);

      if (response.data.sales.status !== 'ATIVO')
        this.getCity();
    })
    .catch(function () {
      let state = this.state;
      state.detailsData = 'error';
      this.setState(state);
    }.bind(this));
  }

  rulesOfActions(sales) {
    let state = this.state;
    let typeUser = localStorage.getItem('planos_y');
    let statusSales = sales.status;
    let afterSalesFlag = sales.afterSales;

    state.showActionPendencyField = false;
    state.showActionCancelField = false;

    if (typeUser === 'SALESMAN') {
      state.disabledCardHolderName = false;
      state.disabledCardNumber = false;
      state.disabledCardValidity = false;

      if (statusSales === 'PAGAMENTO PENDENTE') {
        state.showActionCancel = true;

        if (sales.salesmanConfirm === null)
          state.showActionSendAnalyze = true;
        else
          state.showActionSendAnalyze = false;
      }
      else if (statusSales === 'PENDENTE') {
        state.showActionSendAnalyze = true;
      }
      else {
        state.showActionS4 = false;
        state.showActionSendAfterSales = false;
        state.showActionPendency = false;
        state.showActionCancel = false;
        state.showActionSendAnalyze = false;

        if (this.state.detailsData.financialManager.TypeFm === "SERVIDOR")
          state.showFileAverbation = true;
      }
    }// Fim SALESMAN

    else if (typeUser === 'REGISTER') {
      state.disabledCardHolderName = false;
      state.disabledCardNumber = false;
      state.disabledCardValidity = false;

      if (statusSales === 'EM VALIDAÇÃO') {
        state.showActionS4 = true;
        state.showActionPendency = true;
        state.showActionCancel = true;
      }
      else if (statusSales === 'PENDENTE') {
        state.showActionCancel = true;
        state.showActionS4 = true;
      }
      else if (statusSales === 'EM AVERBAÇÃO' || statusSales === 'FUNCIONÁRIO DE EMPRESA') {
        state.showActionS4 = true;
        state.showActionPendency = true;
        state.showActionCancel = true;
      }
      else {
        state.showActionS4 = false;
        state.showActionPendency = false;
        state.showActionCancel = false;
        state.showActionSendAnalyze = false;
      }
    }// Fim REGISTER

    else if (typeUser === 'AFTER SALES') {
      if (statusSales === 'EM VALIDAÇÃO') {

        // Caso esteja no pós venda
        if (afterSalesFlag === true) {
          state.showActionSendAfterSales = false;
        }
        else
          state.showActionSendAfterSales = true;

        state.showActionS4 = true;
        state.showActionPendency = true;
        state.showActionCancel = true;
      }
      else if (statusSales === 'PENDENTE') {
        state.showActionCancel = true;
      }
      else {
        state.showActionS4 = false;
        state.showActionSendAfterSales = false;
        state.showActionPendency = false;
        state.showActionCancel = false;
        state.showActionSendAnalyze = false;
      }
    }// Fim AFTER SALES

    else {
      state.showActionS4 = false;
      state.showActionSendAfterSales = false;
      state.showActionPendency = false;
      state.showActionCancel = false;
      state.showActionSendAnalyze = false;  
    }// Fim outos perfis

    this.setState(state);
  }

  getCity() {
    let dataPost = {
      'idUF': parseInt(this.state.detailsData.financialManager.state)
    };
    let state = this.state;
    state.disabledLoadingCity = true;
    state.disabledLoadingDistrict = true;
    this.setState(state);

    // Pega a lista de cidades
    axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      state.fMCity = this.state.detailsData.financialManager.city;
      state.disabledLoadingCity = false;
      state.disabledLoadingDistrict = false;
      this.setState(state);

      // Pega os bairros
      this.getDistrict();
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de municípios pelo estado', this.state.detailsData);
    }.bind(this));
  }

  getDistrict() {
    let dataPost = {
      'idCity': parseInt(this.state.detailsData.financialManager.city)
    };
    let state = this.state;
    state.disabledLoadingDistrict = true;
    this.setState(state);

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      state.fMDistrict = this.state.detailsData.financialManager.district;
      state.disabledLoadingDistrict = false;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade', this.state.detailsData);
    }.bind(this));
  }

  onChangeMonth(event) {
    let state = this.state;
    let month = event.target.value;
    state.detailsData.holder.dateFirstPayment = state.detailsData.holder.dateFirstPayment.substr(0,4) + month;

    for (let i = 0; i < this.state.detailsData.dependents.length; i++) {
      state.detailsData.dependents[i].dateFirstPayment = state.detailsData.dependents[i].dateFirstPayment.substr(0,4) + month;
    }

    this.updateDependents();
    this.setState(state);
  }

  onChangeYear(event) {
    let state = this.state;
    let year = event.target.value;;
    state.detailsData.holder.dateFirstPayment = year + state.detailsData.holder.dateFirstPayment.substr(4,6);

    for (let i = 0; i < this.state.detailsData.dependents.length; i++) {
      state.detailsData.dependents[i].dateFirstPayment = year + state.detailsData.dependents[i].dateFirstPayment.substr(4,6);
    }

    this.updateDependents();
    this.setState(state);
  }

  updateDependents() {
    let dataSubmit = {
      financialManagerId: this.state.detailsData.financialManager.id,
      firstPayment: this.state.detailsData.holder.dateFirstPayment
    };

    axios.post(configBase.api + 'Dependents/updateFirstPayment?access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do dependente', this.state.detailsData);
    }.bind(this));
  }

  updateFieldSales(e) {
    let state = this.state;
    state.detailsData.sales[e.target.name] = e.target.value;
    this.setState(state);
  }

  updateDBSales(field) {
    let dataSubmit = {};

    if (this.state.detailsData.sales[field]) {
      dataSubmit[field] = this.state.detailsData.sales[field];

      axios.post(configBase.api + 'Sales/upsertWithWhere?where={"id":"'+ this.state.detailsData.sales.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
      .then(() => {
        
      })
      .catch(function () {
        this.setError('Problema encontrado ao salvar dados da venda', this.state.detailsData);
      }.bind(this));
    }
  }

  updateFieldFM(e) {
    let state = this.state;

    if (e.target.name === 'city') {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      state.fMCity = e.target.value;
      this.setState(state);
      this.getDistrict();
    }
    else if (e.target.name === 'district') {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      state.fMDistrict = e.target.value;
      this.setState(state);
    }
    else if (e.target.name === 'state') {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      this.setState(state);
      this.getCity();
    }
    else {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      this.setState(state);
    }
  }

  updateDBFinancialManager(field) {
    let dataSubmit = {};
    let commonFields = [
      'firstName', 'dateOfBirth', 'gender', 'maritalStatus', 'motherName', 'susNumber'
    ];

    // Retira a máscara da data do cartão
    if (field === 'cardValidity')
      dataSubmit[field] = this.state.detailsData.financialManager[field].replace('/', '');
    else {
      // Cria formato correto da data de admissão
      if (field === 'admissionDate') {
        let admissionDate = this.state.detailsData.financialManager.admissionDate.split('-');
        dataSubmit[field] = admissionDate[2]+'/'+admissionDate[1]+'/'+admissionDate[0];
      }
      else
        dataSubmit[field] = this.state.detailsData.financialManager[field];
    }

    axios.post(configBase.api + 'FinancialManagers/upsertWithWhere?where={"id":"'+ this.state.detailsData.financialManager.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {
      // Verifica se o Responsável Financeiro e o titular são o mesmo
      if (this.state.detailsData.financialManager.cpf === this.state.detailsData.holder.cpf) {
        if (commonFields.indexOf(field) >= 0) {
          this.updateFieldHolder(field, null, this.state.detailsData.financialManager[field]);
          this.updateDBHolder(field);
        }
      }

      // Atualiza os dados da proposta na tela
      if (field === 'cardNumber' || field === 'cardFlag')
        this.getDetails(this.state.detailsData.sales.id);
    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do responsável financeiro', this.state.detailsData);
    }.bind(this));
  }

  updateFieldDate(model, field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      day = value.getDate();
      month = value.getMonth() + 1;
      year = value.getFullYear();;

      if (day < 10)
        day = '0'+ day;
      if (month < 10)
        month = '0'+ month;

      state.detailsData[model][field] = year+'-'+month+'-'+day;
      this.setState(state);

      // Salva no banco
      if (model === 'holder') {
        if (this.validateAgeHolder() === true)
          this.updateDBHolder(field);
      }
      else
        this.updateDBFinancialManager(field);
    }
  }

  updateFieldHolder(id, event, value=null) {
    let state = this.state;

    if (value === null)
      state.detailsData.holder[id] = event.target.value.replace('R$ ', '');
    else
      state.detailsData.holder[id] = value.replace('R$ ', '');

    this.setState(state);
  }

  updateDBHolder(field) {
    let dataSubmit = {};

    if (field === 'valuePlan') {
      let value = this.state.detailsData.holder[field];

      if (value.indexOf('.') >= 0)
        value = value.split('.');
      else
        value = value.split(',');

      if (value[1]) {
        if (value[1].length === 1) {
          value = value[0] + ',' + value[1] + '0';
        }
        else if (value[1].length === 0) {
          value = value[0] + ',00';
        }
      }
      else {
        value = value[0] + ',00';
      }

      dataSubmit[field] = value;
    }
    else
      dataSubmit[field] = this.state.detailsData.holder[field];

    axios.post(configBase.api + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.detailsData.holder.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do titular', this.state.detailsData);
    }.bind(this));
  }

  updateCurrencydHolder(event, value) {
    let state = this.state;
    state.detailsData.holder[event.target.name] = value;
    this.setState(state);
  }

  updateFieldDependent(id, index, event) {
    let state = this.state;
    state.detailsData.dependents[index][id] = event.target.value;
    this.setState(state);
  }

  updateDBDependent(field, index) {
    let dataSubmit = {};

    if (field === 'valuePlan') {
      let value = this.state.detailsData.dependents[index][field];

      if (value.indexOf('.') >= 0)
        value = value.split('.');
      else
        value = value.split(',');

      if (value[1]) {
        if (value[1].length === 1) {
          value = value[0] + ',' + value[1] + '0';
        }
        else if (value[1].length === 0) {
          value = value[0] + ',00';
        }
      }
      else {
        value = value[0] + ',00';
      }

      dataSubmit[field] = value;
    }
    else
      dataSubmit[field] = this.state.detailsData.dependents[index][field];

    axios.post(configBase.api + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.detailsData.dependents[index].id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do dependente', this.state.detailsData);
    }.bind(this));
  }

  updatedDependentsDate(index, field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      day = value.getDate();
      month = value.getMonth() + 1;
      year = value.getFullYear();;

      if (day < 10)
        day = '0'+ day;
      if (month < 10)
        month = '0'+ month;

      state.detailsData.dependents[index][field] = year+'-'+month+'-'+day;
      this.setState(state);

      if (this.validateAgeDep(index) === true)
        this.updateDBDependent(field, index);
    }
  }

  updateCurrencydDependents(index, event, value) {
    let state = this.state;
    state.detailsData.dependents[index][event.target.name] = value;
    this.setState(state);
  }

  getAddress() {
    let valueCep = this.state.detailsData.financialManager.cep;
    let state = this.state;
    state.disabledLoadingAddressType = true;
    state.disabledLoadingAddress = true;
    state.disabledLoadingAddressNumber = true;
    state.disabledLoadingAddressComplement = true;
    state.disabledLoadingState = true;
    state.disabledLoadingCity = true;
    state.disabledLoadingDistrict = true;
    this.setState(state);

    if (valueCep.length >= 8) {
      let dataPost = {
        'cep': valueCep
      };

      axios.post(configBase.api + 'APIS4s/Endereco?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        if (result.data !== null) {
          // Atualiza a lista de cidades e de bairros
          let state = this.state;
          state.cityList = [];
          state.districtList = [];
          state.detailsData.financialManager.addressType = result.data.IdTipoLogradouro;
          state.detailsData.financialManager.address = result.data.Logradouro;
          state.detailsData.financialManager.state = result.data.IdUf;
          this.setState(state);

          // Salva o Responsável Financeiro no banco
          this.updateDBFinancialManager('cep');
          this.updateDBFinancialManager('addressType');
          this.updateDBFinancialManager('address');
          this.updateDBFinancialManager('state');

          this.getCityEdit(function (stateCity) {
            stateCity.detailsData.financialManager.addressType = result.data.IdTipoLogradouro;

            stateCity.detailsData.financialManager.city = result.data.IdMunicipio;
            stateCity.fMCity = result.data.Municipio;
            this.setState(stateCity);

            this.getDistrictEdit(function (stateDistrict) {
              // Salva o Responsável Financeiro no banco
              this.updateDBFinancialManager('city');

              stateDistrict.detailsData.financialManager.district = result.data.IdBairro;
              stateDistrict.fMDistrict = result.data.Bairro;

              // Salva o Responsável Financeiro no banco
              this.updateDBFinancialManager('district');

              document.getElementById('fm_addressNumber').focus();

              stateDistrict.disabledLoadingAddressType = false;
              stateDistrict.disabledLoadingAddress = false;
              stateDistrict.disabledLoadingAddressNumber = false;
              stateDistrict.disabledLoadingAddressComplement = false;
              stateDistrict.disabledLoadingState = false;
              stateDistrict.disabledLoadingCity = false;
              stateDistrict.disabledLoadingDistrict = false;
              this.setState(stateDistrict);
            }.bind(this));
          }.bind(this));
        }
        else {
          let state = this.state;
          state.disabledLoadingAddressType = false;
          state.disabledLoadingAddress = false;
          state.disabledLoadingAddressNumber = false;
          state.disabledLoadingAddressComplement = false;
          state.disabledLoadingState = false;
          state.disabledLoadingCity = false;
          state.disabledLoadingDistrict = false;
          this.setError('CEP inválido', this.state.detailsData);
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar endereço pelo CEP', this.state.detailsData);
      }.bind(this));
    }
    else {
      let state = this.state;
      state.disabledLoadingAddressType = false;
      state.disabledLoadingAddress = false;
      state.disabledLoadingAddressNumber = false;
      state.disabledLoadingAddressComplement = false;
      state.disabledLoadingState = false;
      state.disabledLoadingCity = false;
      state.disabledLoadingDistrict = false;
      this.setState(state);
    }
  }

  getCityEdit(cb=null) {
    let chosenState = 0;
    chosenState = this.state.detailsData.financialManager.state;

    let dataPost = {
      'idUF': parseInt(chosenState)
    };

    // Pega a lista de cidades
    axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      state.disabledLoadingCity = false;

      this.setState(state);

      if (cb !== null)
        cb(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de municípios pelo estado', this.state.detailsData);
    }.bind(this));
  }

  getDistrictEdit(cb=null) {
    let chosenCity = 0;
    chosenCity = this.state.detailsData.financialManager.city;
    let dataPost = {
      idCity: parseInt(chosenCity)
    };

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);

      if (cb !== null)
        cb(state);
    })
    .catch(function (error) {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade', this.state.detailsData);
    }.bind(this));
  }

  setError(msg, contentTable='error') {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    state.detailsData = contentTable;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  openWindow(image, title) {
    let url = `${process.env.PUBLIC_URL}/visualizardoc?doc=${image}`;

    window.open(
      url,
      title,
      "location,status,scrollbars,resizable,width=800, height=800"
    );
  }

  dropzoneDialogOpen(typeFile=null) {
    let state = this.state;
    state.dropzoneDialog = true;

    if (typeFile !== null)
      state.typeFile = typeFile;

    this.setState(state);
  }

  dropzoneDialogClose() {
    let state = this.state;
    state.dropzoneDialog = false;
    this.setState(state);
  }

  fileToBase64(files) {
    /*
    * @type pode ser: "cpf", "rg", "rg2", "resid", "credtFrontal", "physicalContract", "adtive", "others", "declarationPortability"
    */

    let reader = new FileReader();
    let file = files[0];
    /* let state = this.state;
    state.detailsData.imagesDoc[this.state.typeFile] = '';
    this.setState(state); */

    reader.onloadend = function() {
      let dataSubmit = {
        id: this.state.detailsData.financialManager.id,
        imagesDocId: this.state.detailsData.imagesDoc.id,
        imagesDocs: {
          cpf: '',
          rg: '',
          rg2: '',
          address: '',
          credtFrontal: '',
          physicalContract: '',
          adtive: '',
          others: '',
          declarationPortability: '',
          averbation: '',
        }
      };

      if (this.state.typeFile === 'resid')
        dataSubmit.imagesDocs.address = reader.result;
      else
        dataSubmit.imagesDocs[this.state.typeFile] = reader.result;

      axios.post(configBase.api + 'ImagesDocs/saveDocsFinancialManager?access_token='+localStorage.getItem('planos_t'), dataSubmit)
      .then((response) => {
        let state = this.state;
        state.detailsData.imagesDoc = response.data.images;

        let ext = state.detailsData.imagesDoc[this.state.typeFile].substr(
          state.detailsData.imagesDoc[this.state.typeFile].length - 3,
          state.detailsData.imagesDoc[this.state.typeFile].length
        ).toLowerCase();

        state.detailsData.imagesDoc[this.state.typeFile] = state.detailsData.imagesDoc[this.state.typeFile]+'?v='+new Date().getTime()+ext;
        this.setState(state);

        this.dropzoneDialogClose();

        this.forceUpdate();
      })
      .catch(function () {
        this.setError('Problema encontrado ao salvar documento', this.state.detailsData);
      }.bind(this));

    }.bind(this);
    reader.readAsDataURL(file);
  }

  handleConfirmOpen(question, action, txtButton) {
    /*
    * @action pode ser: "cancel", "pending", "analyze", "activate", "sus"
    */

    let state = this.state;
    state.modalConfirmOpen = true;
    state.modalConfirmQuestionContent = question;
    state.modalConfirmQuestion = true;
    state.modalConfirmActionType = action;
    state.modalConfirmButton = txtButton;

    this.fullScreenModalFn();
  }

  handleConfirmClose () {
    let state = this.state;
    state.modalConfirmOpen = false;
    state.msgSus = 'Caso a proposta esteja revisada, aprovada e pronta para ser efetivada, clique no botão ATIVAR.';
    state.msgFileAverbation = '';
    state.modalConfirmActionType = '';
    state.msgContinue = false;
    this.setState(state);
  }

  actionsModal() {
    let state = this.state;
    state.modalConfirmQuestion = false;
    this.setState(state);
  }

  updateFieldCancel(e) {
    let state = this.state;
    state.fieldCancel = e.target.value;
    this.setState(state);
  }

  actionCancellationsDB() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let cancelId = this.state.fieldCancel;

    if (cancelId !== 'null') {
      let url = configBase.api + 'FinancialManagers/upsertWithWhere?where={"id":"' + this.state.detailsData.financialManager.id + '"}&access_token='+localStorage.getItem('planos_t');
      let now = new Date(
        this.state.currentTimeServer.year,
        (this.state.currentTimeServer.month + 1),
        this.state.currentTimeServer.day,
        this.state.currentTimeServer.hours,
        this.state.currentTimeServer.minutes,
        this.state.currentTimeServer.seconds,
      );

      let dataPost = {
        protocoloCancelamento: '416525' + now.getFullYear() +
          ("0" + (now.getMonth() + 1)).substr(-2) +
          ("0" + now.getDate()).substr(-2)+Math.floor(10 + Math.random() * 99) +
          now.getHours() + ("0" +now.getMinutes()).substr(-2)
      };

      // Marca resp financeiro protocolo de cancelamento
      axios.post(url, dataPost)
      .then(() => {
        dataPost = {
          id: this.state.detailsData.sales.id,
          emailOperadora: false,
          cancellationId: cancelId,
        };
        let url = configBase.api + 'Sales/SendEmailCancellation?access_token='+localStorage.getItem('planos_t');
  
        // Cancela proposta
        axios.post(url, dataPost)
        .then(() => {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.setState(state);
          this.handleConfirmClose();
          this.snackbarSuccessOpen('Proposta cancelada com sucesso');
          this.getDetails(this.state.detailsData.sales.id);
        })
        .catch(function () {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.setError('Problema encontrado ao cancelar proposta', this.state.detailsData);
        }.bind(this));
      })
      .catch(function () {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.setError('Problema encontrado ao cancelar proposta', this.state.detailsData);
      }.bind(this));
    }
    else {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.setError('Escolha o motivo do cancelamento', this.state.detailsData);
    }
  }

  updateFieldPending(e) {
    let state = this.state;
    state.fieldPending = e.target.value;
    this.setState(state);
  }

  actionPendencyDB() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let pendencyId = this.state.fieldPending;

    if (pendencyId !== 'null') {
      let dataPost = {
        id: this.state.detailsData.sales.id,
        pendencyId: pendencyId
      };
      let url = configBase.api + 'Sales/SendEmailPendency?access_token='+localStorage.getItem('planos_t');

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.setState(state);
        this.handleConfirmClose();
        this.snackbarSuccessOpen('Proposta pendente salva com sucesso');
        this.getDetails(this.state.detailsData.sales.id);
      })
      .catch(() => {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.setError('Problema encontrado ao salvar proposta como indeferida', this.state.detailsData);
      });
    }
    else {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.setError('Escolha o motivo da indeferência', this.state.detailsData);
    }
  }

  snackbarSuccessOpen(msg) {
    let state = this.state;
    state.snackbarSuccess = true;
    state.msgSnackbarSuccess = msg;
    this.setState(state);
  }

  snackbarSuccessClose() {
    let state = this.state;
    state.snackbarSuccess = false;
    state.msgSnackbarSuccess = '';
    this.setState(state);
  }

  confirmCheckFn(event) {
    let state = this.state;
    state.confirmCheck = event.target.checked;
    this.setState(state);
  }

  sendAnalyze() {
    let dataPost = {
      status: "EM VALIDAÇÃO",
      analyzing: false
    };

    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    if (this.state.detailsData.sales.status === "PENDENTE") {
      axios.post(configBase.api + 'Sales/update?where={"id":"'+this.state.detailsData.sales.id+'"}&access_token='+localStorage.getItem('planos_t'), dataPost)
      .then(() => {
        let state = this.state;
        state.confirm = true;
        state.errorCheck = false;
        state.modalConfirmButtonLoading = false;
        this.handleConfirmClose();
        this.snackbarSuccessOpen('Proposta enviada para análise com sucesso');
        this.getDetails(this.state.detailsData.sales.id);
      })
      .catch(() => {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.handleConfirmClose();
        this.setError('Problema encontrado ao enviar proposta para análise', this.state.detailsData);
      });
    }
    else {
      if (this.state.detailsData.sales.status === 'PAGAMENTO PENDENTE') {
        // Se for PAGAMENTO PENDENTE verifica o check de confirmação
        if (this.state.confirmCheck) {
          // Verifica a confirmação do Responsável Financeiro
          // (Confirmado)
          if (this.state.detailsData.sales.fMConfirm !== null) {
            let dataSendEmailInValidation = {
              id: this.state.detailsData.sales.id,
              type: 'SALESMAN'
            };

            axios.post(configBase.api + 'Sales/SendEmailInValidation?access_token='+localStorage.getItem('planos_t'), dataSendEmailInValidation)
            .then(() => {
              let state = this.state;
              state.confirm = true;
              state.errorCheck = false;
              state.modalConfirmButtonLoading = false;
              this.handleConfirmClose();
              this.snackbarSuccessOpen('Proposta enviada para análise com sucesso');
              this.getDetails(this.state.detailsData.sales.id);
            })
            .catch(() => {
              let state = this.state;
              state.modalConfirmButtonLoading = false;
              this.handleConfirmClose();
              this.setError('Problema encontrado ao enviar proposta para análise', this.state.detailsData);
            });
          }
          // (Não confirmado)
          else {
            let dataConfirm = {
              id: this.state.detailsData.sales.id,
              type: 'SALESMAN'
            };

            axios.post(configBase.api + 'Sales/SendEmailInValidation?access_token='+localStorage.getItem('planos_t'), dataConfirm)
            .then(() => {
              let state = this.state;
              state.confirmFmMensage = "O cliente ainda não realizou a confirmação. Por favor aguarde.";
              state.modalConfirmButtonLoading = false;
              this.handleConfirmClose();
              this.snackbarSuccessOpen('Realizada confirmação da proposta com sucesso');
              this.getDetails(this.state.detailsData.sales.id);
            })
            .catch(() => {
              let state = this.state;
              state.modalConfirmButtonLoading = false;
              this.handleConfirmClose();
              this.setError('Problema encontrado ao enviar proposta para análise', this.state.detailsData);
            });
          }
        }
        else {
          let state = this.state;
          state.errorCheck = true;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();
          this.setError('É necessário declarar o recebimento do pagamento', this.state.detailsData);

          let interval = setInterval(function() {
            if (state.modalConfirmOpen === false) {
              document.getElementById("i_confirmCheck").scrollIntoView();
              clearInterval(interval);
            }
          }, 100);
        }
      }
      else {
        axios.post(configBase.api + 'Sales/update?where={"id":"'+this.state.detailsData.sales.id+'"}&access_token='+localStorage.getItem('planos_t'), dataPost)
        .then(() => {
          let state = this.state;
          state.confirm = true;
          state.errorCheck = false;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();
          this.snackbarSuccessOpen('Proposta enviada para análise com sucesso');
          this.getDetails(this.state.detailsData.sales.id);
        })
        .catch(() => {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.setError('Problema encontrado ao enviar proposta para análise', this.state.detailsData);
        });
      }
    }
  }

  // Usado também em admin/back/common/models/sales.js
  removeAccents(strAccents) {
    strAccents = strAccents.split('');

		var strAccentsOut = [];
		var strAccentsLen = strAccents.length;
		var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";

		for (var y = 0; y < strAccentsLen; y++) {
			if (accents.indexOf(strAccents[y]) !== -1) {
				strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
			} else
				strAccentsOut[y] = strAccents[y];
    }

		strAccentsOut = strAccentsOut.join('');
		return strAccentsOut;
	}

  verifySus() {
    // Verifica cartão do sus dos dependentes
    let holder = this.state.detailsData.holder
    let dependents = this.state.detailsData.dependents;
    let error = false;

    if (holder.susNumber === null || holder.susNumber === undefined || holder.susNumber.length === 0)
      error = true;

    for (let i = 0; i < dependents.length; i++) {
      if (dependents[i].susNumber === null || dependents[i].susNumber === undefined || dependents[i].susNumber.length === 0) {
        error = true;
        break;
      }
    }

    if (error === true) {
      let state = this.state;
      state.msgSus = 'Existem beneficiários com cartão do SUS não informado. Deseja continuar?';
      state.modalConfirmActionType = 'activate';
      this.setState(state);
    }
    else
      this.sendS4();
  }

  beforeSendS4() {
    // Verifica cartão do sus dos dependentes
    let holder = this.state.detailsData.holder
    let dependents = this.state.detailsData.dependents;
    let errorSus = false;
    let errorFileAverbation = false;

    // Verifica o cartão do sus do titular
    if (holder.susNumber === null || holder.susNumber === undefined || holder.susNumber.length === 0)
      errorSus = true;

    // Verifica o cartão do sus para os dependentes
    for (let i = 0; i < dependents.length; i++) {
      if (dependents[i].susNumber === null || dependents[i].susNumber === undefined || dependents[i].susNumber.length === 0) {
        errorSus = true;
        break;
      }
    }

    // Verifica se foi anexado o doc de Comprovante de Averbação
    if (this.state.showFileAverbation === true) {
      if (this.state.detailsData.imagesDoc.averbation === undefined || this.state.detailsData.imagesDoc.averbation.length === 0)
        errorFileAverbation = true;
    }

    if (errorSus === true) {
      let state = this.state;
      state.msgSus = '* Existem beneficiários com cartão do SUS não informado.';
      state.modalConfirmActionType = 'activate';
      state.msgContinue = true;
      this.setState(state);
    }

    if (errorFileAverbation === true) {
      let state = this.state;
      state.msgFileAverbation = '* O documento de Comprovante de Averbação não está anexado.';
      state.msgContinue = true;

      if (errorSus === false)
        state.msgSus = '';

      state.modalConfirmActionType = 'activate';
      this.setState(state);
    }

    if (errorSus === false && errorFileAverbation === false)
      this.sendS4();
  }

  sendS4() {
    // Verifica se tem o código do S4. '----' padrão do back para vendedor não identificado
    if (this.state.detailsData.salesman.codeS4 && this.state.detailsData.salesman.codeS4 !== '----') {
      // Para proposta de boleto
      if (this.state.detailsData.financialManager.formOfPayment === 'BOLETO' && !this.state.detailsData.financialManager.reteveAdesao) {
        let state = this.state;
        state.modalConfirmButtonLoading = true;
        this.setState(state);

        let dataPost = [{
          id: this.state.detailsData.sales.id,
          status: this.state.detailsData.sales.status,
          boletoId: this.state.detailsData.sales.boletoId,
          financialManagerId: this.state.detailsData.sales.financialManagerId,
        }];

        axios.post(configBase.api + 'Sales/enviaPropostaBoleto?access_token='+localStorage.getItem('planos_t'), dataPost)
        .then((response) => {
          let erroS4E = '';

          if (response.data.codigo) {
            if (response.data.codigo !== 1)
              erroS4E = "Problema encontrado ao efetivar proposta: " + response.data.mensagem;
          }

          if (erroS4E.length > 0) {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError(erroS4E, this.state.detailsData);
          }
          else {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.snackbarSuccessOpen('Proposta ativada com sucesso e email enviado');
            this.getDetails(this.state.detailsData.sales.id);
          }
        })
        .catch((error) => {
          let state = this.state;
          state.modalConfirmButtonLoading = false;
          this.handleConfirmClose();

          if (error.response.data) {
            if (error.response.data.error) {
              if (error.response.data.error.message)
                this.setError(error.response.data.error.message, this.state.detailsData);
              else {
                if (error.response.data.error.error) {
                  if (error.response.data.error.error.mensagem)
                    this.setError('Problema encontrado ao efetivar proposta', error.response.data.error.error.mensagem);
                  else
                    this.setError('Problema encontrado ao efetivar proposta', this.state.detailsData);
                }
                else
                  this.setError('Problema encontrado ao efetivar proposta', this.state.detailsData);
              }
            }
            else
              this.setError('Problema encontrado ao efetivar proposta', this.state.detailsData);
          }
          else
            this.setError('Problema encontrado ao efetivar proposta', this.state.detailsData);
        });
      }
      else {
        let errorForm = false;

        let dataPost = {
          financialManagerId: this.state.detailsData.financialManager.id,
          salesId: "",
  
          "dataForS4": {
            "incluirMensalidades": 0,// Apos ocorrer erros, S4E pediu para add esse atributo
            "parceiro": {
              "codigo": this.state.detailsData.broker.codeS4,
              "adesionista": this.state.detailsData.salesman.codeS4,
              "tipoCobranca": 1
            },
            "responsavelFinanceiro": {
              "dataAssinaturaContrato": this.state.detailsData.financialManager.dateSignatureContractS4,
              "codigoContrato": this.state.detailsData.financialManager.contractNumberS4,
              "nome": this.removeAccents(this.state.detailsData.financialManager.firstName),
              "dataNascimento": this.state.detailsData.financialManager.dateOfBirth,
              "cpf": this.state.detailsData.financialManager.cpf.replace(/\D/g, ''),
              "identidadeNumero": this.state.detailsData.financialManager.rg.replace(/\D/g, ''),
              "identidadeOrgaoExpeditor": this.state.detailsData.financialManager.rgEmitter.substring(0,10),
              "sexo": this.state.detailsData.financialManager.gender,
              "endereco": {
                "cep": this.state.detailsData.financialManager.cep.replace(/\D/g, ''),
                "tipoLogradouro": this.state.detailsData.financialManager.addressType,
                "logradouro": this.state.detailsData.financialManager.address,
                "numero": this.state.detailsData.financialManager.addressNumber,
                "complemento": this.removeAccents(this.state.detailsData.financialManager.addressComplement),
                "bairro": this.state.detailsData.financialManager.district,
                "municipio": this.state.detailsData.financialManager.city,
                "uf": this.state.detailsData.financialManager.state
              },
              "contatoResponsavelFinanceiro": []
            },
            "dependente":[]
          }
        };

        // Tipo de pagamento
        if (this.state.detailsData.financialManager.tipoPagamento)
          dataPost.dataForS4.responsavelFinanceiro.tipoPagamento = this.state.detailsData.financialManager.tipoPagamento;

        if (this.state.detailsData.financialManager.formOfPayment === 'CARTAO')
          dataPost.salesId = this.state.detailsData.sales.id;
  
        // Add contato fixo
        if (this.state.detailsData.financialManager.homePhone.replace(/\D/g, '').length > 0) {
          let contact = {
            "tipo": 1,
            "dado": this.state.detailsData.financialManager.homePhone.replace(/\D/g, '')
          };

          dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
        }

        // Add contato celular
        if (this.state.detailsData.financialManager.cellPhone.replace(/\D/g, '').length > 0) {
          let contact = {
            "tipo": 8,
            "dado": this.state.detailsData.financialManager.cellPhone.replace(/\D/g, '')
          };

          dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
        }

        // Add contato celular2
        if (this.state.detailsData.financialManager.cellPhone2.replace(/\D/g, '').length > 0) {
          let contact = {
            "tipo": 8,
            "dado": this.state.detailsData.financialManager.cellPhone2.replace(/\D/g, '')
          };

          dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
        }

        // Add contato email
        if (this.state.detailsData.financialManager.email.length > 0) {
          let contact = {
            "tipo": 50,
            "dado": this.state.detailsData.financialManager.email
          };

          dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
        }

        let holder = {
          "tipo": 1,
          "nome": this.removeAccents(this.state.detailsData.holder.firstName),
          "dataNascimento": this.state.detailsData.holder.dateOfBirth,
          "cpf": this.state.detailsData.holder.cpf.replace(/\D/g, ''),
          "sexo": this.state.detailsData.holder.gender,
          "plano": '',
          "planoValor": this.state.detailsData.holder.valuePlan.replace(',','.'),
          "nomeMae": this.removeAccents(this.state.detailsData.holder.motherName),
          "rcaId": 0,
          "MMYYYY1Pagamento": this.state.detailsData.holder.dateFirstPayment,
          "cns": this.state.detailsData.holder.susNumber,
        };
  
        if (this.state.detailsData.financialManager.modalidadePagamento === 'ANUAL') {
          holder.carenciaAtendimento = 0;
          holder.rcaId = 9;
        }

        if (this.state.detailsData.holder.plans)
          holder.plano = this.state.detailsData.holder.plans.codeS4;
        else// Para o plano do bando do S4E
          holder.plano = this.state.detailsData.financialManager.planCompany.codePlan;

        dataPost.dataForS4.dependente.push(holder);

        for (let i = 0; i < this.state.detailsData.dependents.length; i++) {
          let dependent = {
            "tipo": this.parentageList[this.state.detailsData.dependents[i].parentage],
            "nome": this.removeAccents(this.state.detailsData.dependents[i].firstName),
            "dataNascimento": this.state.detailsData.dependents[i].dateOfBirth,
            "cpf": this.state.detailsData.dependents[i].cpf.replace(/\D/g, ''),
            "sexo": this.state.detailsData.dependents[i].gender,
            "plano": '',
            "planoValor": this.state.detailsData.dependents[i].valuePlan.replace(',','.'),
            "nomeMae": this.removeAccents(this.state.detailsData.dependents[i].motherName),
            "rcaId": 0,
            "MMYYYY1Pagamento": this.state.detailsData.dependents[i].dateFirstPayment,
            "cns": this.state.detailsData.dependents[i].susNumber,
          };
  
          if (this.state.detailsData.financialManager.modalidadePagamento === 'ANUAL') {
            dependent.carenciaAtendimento = 0;
            dependent.rcaId = 9;
          }
  
          if (this.state.detailsData.dependents[i].plans)
            dependent.plano = this.state.detailsData.dependents[i].plans.codeS4;
          else// Para o plano do bando do S4E
            dependent.plano = this.state.detailsData.financialManager.planCompany.codePlan;
  
          dataPost.dataForS4.dependente.push(dependent);
        }

        // Para o cartão de crédito
        if (this.state.planCredtCard === true) {
          // Caso não tenha os dados do cartão
          /* if (!this.state.detailsData.financialManager.cardNumberS4 ||
              !this.state.detailsData.financialManager.cardValidity ||
              !this.state.detailsData.financialManager.cardFlagS4 ||
              !this.state.detailsData.financialManager.cardDayExpiration ||
              !this.state.detailsData.financialManager.cardHolderName) {

                errorForm = true;
                let state = this.state;
                state.modalConfirmButtonLoading = false;
                this.handleConfirmClose();
                this.setError("Cartão de crédito com informações faltantes", this.state.detailsData);
          }
          else { */
            if (this.state.detailsData.financialManager.tokenCartao) {
              dataPost.dataForS4.responsavelFinanceiro.cartao = {
                "id": this.state.detailsData.financialManager.tokenCartao,
              };
            }
            else {
              dataPost.dataForS4.responsavelFinanceiro.cartao = {
                "numero": this.state.detailsData.financialManager.cardNumberS4,
                "validade": this.state.detailsData.financialManager.cardValidity,
                "codSeguraca": "000",
                "bandeira": this.state.detailsData.financialManager.cardFlagS4,
                "diaVencimentoCartao": parseInt(this.state.detailsData.financialManager.cardDayExpiration),
                "nomeImpressoCartao": this.state.detailsData.financialManager.cardHolderName,
              };
            }
          //}
        }

        // Para Servidor Público
        if ((this.state.detailsData.financialManager.TypeFm !== undefined && this.state.detailsData.financialManager.TypeFm === "SERVIDOR") ||
          this.state.detailsData.financialManager.TypeFm === "FUNCIONARIO") {
            dataPost.dataForS4.responsavelFinanceiro.matricula = this.state.detailsData.financialManager.matricula;
            let admissionDate = this.state.detailsData.financialManager.admissionDate.split('/');
            dataPost.dataForS4.responsavelFinanceiro.dataApresentacao = admissionDate[2]+'/'+admissionDate[1]+'/'+admissionDate[0];
        }

        if (errorForm === false) {
          let state = this.state;
          state.modalConfirmButtonLoading = true;
          this.setState(state);
  
          axios.post(configBase.api + 'APIS4s/NovoUsuario?access_token='+localStorage.getItem('planos_t'), dataPost)
          .then((response) => {
            if (response.data.codigo === 1) {
              let sendEmailActive = {
                id: this.state.detailsData.sales.id
              };

              this.snackbarSuccessOpen('Proposta ativada com sucesso. Enviando email para responsável financeiro...');

              axios.post(configBase.api + 'Sales/SendEmailActive?access_token='+localStorage.getItem('planos_t'), sendEmailActive)
              .then(() => {
                this.snackbarSuccessClose();
                let state = this.state;
                state.modalConfirmButtonLoading = false;
                this.handleConfirmClose();
                this.snackbarSuccessOpen('Proposta ativada com sucesso e email enviado');
                this.getDetails(this.state.detailsData.sales.id);
              })
              .catch(() => {
                let state = this.state;
                state.modalConfirmButtonLoading = false;
                this.handleConfirmClose();
                this.setError('Porposta ativada, porém, houve um problema no envio de email ao responsável financeiro', this.state.detailsData);
              });
            }
            else {
              let state = this.state;
              state.modalConfirmButtonLoading = false;
              this.handleConfirmClose();
              this.setError("Problema encontrado ao efetivar proposta: " + response.data.mensagem, this.state.detailsData);
            }
          })
          .catch(() => {
            let state = this.state;
            state.modalConfirmButtonLoading = false;
            this.handleConfirmClose();
            this.setError('Problema encontrado ao efetivar proposta', this.state.detailsData);
          });
        }
      }
    }
    else {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.handleConfirmClose();
      this.setError("Código do parceiro (vendedor) não identificado", this.state.detailsData);
    }
  }

  baixarBoleto(event) {
    event.preventDefault();
    let boletoId = '';
    let state = this.state;
    state.showLoadindDowloadPdf = true;
    this.setState(state);

    if (this.state.detailsData.sales.boletoAtual)
      boletoId = this.state.detailsData.sales.boletoAtual;
    else
      boletoId = this.state.detailsData.sales.boletoId;

    axios.get('https://p4x.srv.br/api/v1.0/boletos/'+boletoId+'/imprimir', {
      responseType: 'arraybuffer',
      headers: {
        'Content-type': 'application/pdf'
      }
    })
    .then((response) => {
      let file = new Blob([response.data], {type: 'application/pdf'});
      let fileURL = URL.createObjectURL(file);
      let link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', 'boleto.pdf');
      document.body.appendChild(link);
      link.click();

      let state = this.state;
      state.showLoadindDowloadPdf = false;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado gerar boleto', this.state.detailsData);
    }.bind(this));
  }

  validateAgeHolder() {
    let result = true;
    let value = this.state.detailsData.holder.dateOfBirth;
    value = new Date(value);

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      if (this.state.detailsData.plan.idadeMaxima) {
        if (this.getAge(this.state.detailsData.holder.dateOfBirth) > parseInt(this.state.detailsData.plan.idadeMaxima)) {
          result = false;
          this.setError(
            'Idade não permitida para o plano selecionado. Máximo '+ this.state.detailsData.plan.idadeMaxima+' anos.',
            this.state.detailsData
          );
        }
      }
    }

    return result;
  }

  validateAgeDep(index) {
    let result = true;
    let value = this.state.detailsData.dependents[index].dateOfBirth;
    value = new Date(value);

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      if (this.state.detailsData.plan.idadeMaxima) {
        if (this.getAge(this.state.detailsData.dependents[index].dateOfBirth) > parseInt(this.state.detailsData.plan.idadeMaxima)) {
          result = false;
          this.setError(
            'Idade não permitida para o plano selecionado. Máximo '+ this.state.detailsData.plan.idadeMaxima+' anos.',
            this.state.detailsData
          );
        }
      }
    }

    return result;
  }

  getAge(date) {
    let part = date.split('-'),
        dateIs = new Date(this.state.currentTimeServer.year, this.state.currentTimeServer.month, this.state.currentTimeServer.day),//data atual
        day = dateIs.getDate(),
        year = dateIs.getFullYear(),
        month = dateIs.getMonth() + 1;

    let age = '';

    age = year - part[0];

    if (month < parseInt(part[1]) || (month === parseInt(part[1]) && day < parseInt(part[2])))
      age--;

    return age;
  }

  detalhes() {
    return (
      <div id="detalhes">
        {/* Para as pendências */
          this.state.detailsData.sales.status === 'PENDENTE' ? (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Proposta Indeferida
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Alert severity="error">{this.state.detailsData.sales.pendency}</Alert>
              </Grid>
            </Grid>
          </div>
        </Paper>
          ) : (
            this.state.detailsData.sales.status === 'CANCELADO' ? (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Proposta Cancelada
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {
                  this.state.detailsData.financialManager.protocoloCancelamento ? (
                <Alert severity="error">
                  {this.state.detailsData.sales.cancellation} - Protocolo - {this.state.detailsData.financialManager.protocoloCancelamento}
                </Alert>
                  ) : (
                <Alert severity="error">{this.state.detailsData.sales.cancellation}</Alert>
                  )
                }
              </Grid>
            </Grid>
          </div>
        </Paper>
            ) : ('')
          )
        }

        {
          this.state.detailsData.sales.status === 'ATIVO' && (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Implantação no S4E
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  disabled
                  fullWidth
                  label="Código Contrato"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={
                    this.state.detailsData.financialManager.codeSaveS4Contract ? (
                      this.state.detailsData.financialManager.codeSaveS4Contract
                    ) : ('-----')
                  }
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
          )
        }


        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Plano Contratado
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
            {
              this.state.detailsData.financialManager.plansId ? ('') : (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Fantasia"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.planCompany.fantasyName}
                />
                </Grid>
              )
            }
            {
              this.state.detailsData.financialManager.plansId ? ('') : (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Razão Social"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.planCompany.corporateName}
                />
              </Grid>
              )
            }
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Plano"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.plan.name}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  disabled
                  fullWidth
                  label="R$ por Mês"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.responsibility}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  disabled
                  fullWidth
                  label="Adesão Dia"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.dateSignatureContract}
                />
              </Grid>

              {
                this.state.detailsData.financialManager.TypeFm === "SERVIDOR" && (
                  this.state.detailsData.financialManager.orgaoAverbador ? (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Órgão Averbador"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.orgaoAverbador.orgao}
                />
              </Grid>
                  ) : (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Órgão Averbador"
                  type="text"
                  variant="outlined"
                  size="small"
                  value="Não Encontrado"
                />
              </Grid>
                  )
                )
              }
            </Grid>
          </div>
        </Paper>

        {
          this.state.showFirstPayment === true ? (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Mês e Ano do Primeiro Pagamento
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="dateFirstPaymentMonth"
                  fullWidth
                  select
                  label="Mês"
                  variant="outlined"
                  size="small"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.holder.dateFirstPayment ? this.state.detailsData.holder.dateFirstPayment.substr(4,6) : '00'}
                  onChange={this.onChangeMonth.bind(this)}
                >
                  <option value="00">Mês</option>
                  <option value="01">Janeiro</option>
                  <option value="02">Fevereiro</option>
                  <option value="03">Março</option>
                  <option value="04">Abril</option>
                  <option value="05">Maio</option>
                  <option value="06">Junho</option>
                  <option value="07">Julho</option>
                  <option value="08">Agosto</option>
                  <option value="09">Setembro</option>
                  <option value="10">Outubro</option>
                  <option value="11">Novembro</option>
                  <option value="12">Dezembro</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="dateFirstPaymentYear"
                  fullWidth
                  select
                  label="Ano"
                  variant="outlined"
                  size="small"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.holder.dateFirstPayment ? this.state.detailsData.holder.dateFirstPayment.substr(0,4) : '00'}
                  onChange={this.onChangeYear.bind(this)}
                >
                  <option value="00">Ano</option>
                {this.state.listYear.map((item, index) =>
                  <option key={index} value={item}>{item}</option>
                )}
                </TextField>
              </Grid>
            </Grid>
          </div>
        </Paper>
          ) : ('')
        }

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Corretora e Vendedor
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Corretora"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.broker.user.name}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Vendedor"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.salesman.user.name}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  disabled
                  fullWidth
                  label="Código S4E"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.salesman.codeS4}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Informações do Pagamento
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          {
            this.state.planCredtCard === true ? (
          <div className="paper">
            {
              this.state.detailsData.financialManager.reteveAdesao === false ? (
            <div style={{marginBottom: 15}}>
              <Typography variant="overline">
                REALIZADO COM CARTÃO DE CRÉDITO
              </Typography>
            </div>
              ) : (
            <div style={{marginBottom: 15}}>
              <Typography variant="overline" style={{color: '#fb8c00'}}>
                REALIZADO COM CARTÃO DE CRÉDITO (ADESÃO RETIDA PELO VENDEDOR)
              </Typography>
            </div>
              )
            }

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  disabled={this.state.disabledCardHolderName}
                  fullWidth
                  label="Titular"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="cardHolderName"
                  value={this.state.detailsData.financialManager.cardHolderName}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cardHolderName')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  disabled={this.state.cardNumber}
                  fullWidth
                  label="Número"
                  type="tel"
                  variant="outlined"
                  size="small"
                  name="cardNumber"
                  value={this.state.detailsData.financialManager.cardNumber}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cardNumber')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  fullWidth
                  select
                  label="Bandeira"
                  variant="outlined"
                  size="small"
                  name="cardFlag"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.cardFlag}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cardFlag')}
                >
                  <option value="null">Bandeira</option>
                {this.state.cardFlagList.map((item, index) =>
                  <option key={index} value={item.name}>{item.name}</option>
                )}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <InputMask
                  mask="99/9999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cardValidity}
                  disabled={this.state.disabledCardValidity}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cardValidity')}
                >
                  {() => <TextField
                    fullWidth
                    label="Válido Até"
                    variant="outlined"
                    size="small"
                    name="cardValidity"
                    disabled={this.state.disabledCardValidity}
                    helperText="MM/AAAA"
                  />}
                </InputMask>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  disabled
                  fullWidth
                  label="NSU"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={
                    this.state.detailsData.financialManager.nsu ? (
                      this.state.detailsData.financialManager.nsu
                    ) : ('----------')
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  disabled
                  fullWidth
                  label="Cód. Autorização"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={
                    this.state.detailsData.financialManager.autorizacaoCodigo ? (
                      this.state.detailsData.financialManager.autorizacaoCodigo
                    ) : ('----------')
                  }
                />
              </Grid>
            </Grid>
          </div>
          ) : (
          <div className="paper">
            <div>
              {
                this.state.detailsData.financialManager.formOfPayment === 'BOLETO' ? (
                  this.state.detailsData.financialManager.reteveAdesao === false ? (
              <div>
                <Typography variant="button">
                  BOLETO BANCÁRIO
                </Typography>

                {
                  this.state.vencBoleto.length > 0 && (
                <div style={{marginTop: 8}}>
                  <Typography variant="overline" display="block" gutterBottom>
                    VENCIMENTO: {this.state.vencBoleto}
                  </Typography>
                </div>
                  )
                }

                {
                  this.state.detailsData.financialManager.situacaoBoleto ? (
                 <div style={{marginTop: 8}}>
                  <Typography variant="overline" display="block" gutterBottom>
                    SITUAÇÃO: {this.state.detailsData.financialManager.situacaoBoleto}
                  </Typography>
                </div>
                  ) : ('')
                }

                {
                  this.state.detailsData.financialManager.nossoNumero ? (
                 <div style={{marginTop: 8}}>
                  <Typography variant="overline" display="block" gutterBottom>
                    Nosso Número: {this.state.detailsData.financialManager.nossoNumero.toString().slice(0, -1)}
                  </Typography>
                </div>
                  ) : ('')
                }

                <div>
                  {
                    this.state.showLoadindDowloadPdf === true ? (
                  <CircularProgress />
                    ) : (
                  <Link
                    href="#"
                    onClick={this.baixarBoleto.bind(this)}
                    style={{textDecoration: 'underline'}}
                  >
                    Vizualizar boleto
                  </Link>
                    )
                  }

                </div>
              </div>
                  ) : (
              <Typography variant="button">
                ADESÃO RETIDA PELO VENDEDOR
              </Typography>
                  )
                ) : (
              <Typography variant="button">
                DESCONTO EM FOLHA
              </Typography>
                )
              }

            </div>
          </div>
          )
        }
        </Paper>

        {
          localStorage.getItem('planos_y') === 'SALESMAN' ? (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Observações para a {configBase.empresaMiniscula}
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  multiline={true}
                  fullWidth
                  label="Texto da observação"
                  type="text"
                  variant="outlined"
                  size="small"
                  rows={8}
                  rowsMax={16}
                  value={this.state.detailsData.sales.observation}
                  name="observation"
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldSales.bind(this)}
                  onBlur={this.updateDBSales.bind(this, 'observation')}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
          ) : (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Observações do vendedor
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <div>
              {
                this.state.detailsData.sales.observation !== undefined ? (
                  this.state.detailsData.sales.observation.length > 0 ? (
              <Typography variant="button">
                {this.state.detailsData.sales.observation}
              </Typography>
                ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <MuiAlert severity="info" variant="filled" elevation={0}>
                    Sem observações cadastrada
                  </MuiAlert>
                </Grid>
              </Grid>
                      )
                ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <MuiAlert severity="info" variant="filled" elevation={0}>
                    Sem observações cadastrada
                  </MuiAlert>
                </Grid>
              </Grid>
                )
              }

            </div>
          </div>
        </Paper>
          )
        }

        {/* Para a Primeira Parcela */
          localStorage.getItem('planos_y') === 'SALESMAN' ? (
            (this.state.detailsData.sales.status !== 'PENDENTE' && this.state.detailsData.sales.status !== 'CANCELADO') ? (
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Pagamento da Adesão
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper" id="i_confirmCheck">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
              {
                this.state.confirm === false ? (
                <FormControl required error={this.state.errorCheck} component="fieldset">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.confirmCheck}
                        onChange={this.confirmCheckFn.bind(this)}
                        name="confirm_check"
                        style={{color: configBase.corPrincipal}}
                      />
                    }
                    label={"Declaro que recebi do responsável financeiro o valor de R$ " + this.state.detailsData.financialManager.responsibility + " referente a adesão do plano."}
                  />
                  {
                    this.state.errorCheck === true ? (
                  <FormHelperText>Pagamento da adesão já recebido?</FormHelperText>
                    ) : ('')
                  }
                </FormControl>
                ) : (
                  this.state.confirmFmMensage.length > 0 ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={7} lg={7}>
                    <MuiAlert severity="info" variant="filled" elevation={0}>
                      {this.state.confirmFmMensage}
                    </MuiAlert>
                  </Grid>
                </Grid>
                  ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={7} lg={7}>
                    {
                      this.state.detailsData.financialManager.formOfPayment === 'BOLETO' ? (
                        this.state.detailsData.sales.status !== 'ATIVO' ? (
                    <MuiAlert severity="info" variant="filled" elevation={0}>
                      Aguardando compensação do boleto bancário
                    </MuiAlert>
                        ) : (
                    <MuiAlert severity="info" variant="filled" elevation={0}>
                      Pagamento já realizado pelo cliente
                    </MuiAlert>
                        )
                      ) : (
                    <MuiAlert severity="info" variant="filled" elevation={0}>
                      Pagamento já realizado pelo cliente
                    </MuiAlert>
                      )
                    }

                  </Grid>
                </Grid>
                  )
                )
              }
              </Grid>
            </Grid>
          </div>
        </Paper>
            ) : ('')
          ) : ('')
        }

      </div>
    );
  }

  responsavelFinanceiro() {

    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Informações do Responsável Financeiro
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={this.state.detailsData.financialManager.firstName}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'firstName')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Mãe"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="motherName"
                  value={this.state.detailsData.financialManager.motherName}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'motherName')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <InputMask
                  mask="(99) 9999-9999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.homePhone}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'homePhone')}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                >
                  {() => <TextField
                    fullWidth
                    label="Tel. Fixo"
                    variant="outlined"
                    size="small"
                    name="homePhone"
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cellPhone}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cellPhone')}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                >
                  {() => <TextField
                    fullWidth
                    label="Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone"
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cellPhone2}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cellPhone2')}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                >
                  {() => <TextField
                    fullWidth
                    label="2º Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone2"
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  />}
                </InputMask>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
               <TextField
                  fullWidth
                  label="Email"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="email"
                  value={this.state.detailsData.financialManager.email}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'email')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  fullWidth
                  label="RG"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="rg"
                  value={this.state.detailsData.financialManager.rg}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'rg')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  fullWidth
                  label="Org. Emissor"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="rgEmitter"
                  value={this.state.detailsData.financialManager.rgEmitter}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'rgEmitter')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Cartão do SUS"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="susNumber"
                  value={this.state.detailsData.financialManager.susNumber}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'susNumber')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cpf}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                >
                  {() => <TextField
                    fullWidth
                    label="CPF"
                    variant="outlined"
                    size="small"
                    name="cpf"
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Data de Nascimento"
                    format="dd/MM/yyyy"
                    size="small"
                    name="dateOfBirth"
                    value={new Date(this.state.detailsData.financialManager.dateOfBirth+'T00:00:00')}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDate.bind(this, 'financialManager', 'dateOfBirth')}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="maritalStatus"
                  fullWidth
                  select
                  label="Estado Civil"
                  variant="outlined"
                  size="small"
                  name="maritalStatus"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.maritalStatus}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'maritalStatus')}
                >
                  <option value="SOLTEIRO">Solteiro</option>
                  <option value="CASADO">Casado</option>
                  <option value="VIÚVO">Viúvo</option>
                  <option value="SEPARADO">Separado</option>
                  <option value="DIVORCIADO">Divorciado</option>
                  <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="gender"
                  fullWidth
                  select
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  name="gender"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.gender}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'gender')}
                >
                  <option value="0">Feminino</option>
                  <option value="1">Masculino</option>
                </TextField>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
            {
                this.state.showMatricula === true ? (
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Matrícula"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="matricula"
                  value={this.state.detailsData.financialManager.matricula}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'matricula')}
                />
              </Grid>
                ) : ('')
              }

              {
                this.state.showAdmissionDate === true ? (
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Data de Admissão"
                    format="dd/MM/yyyy"
                    size="small"
                    name="admissionDate"
                    value={new Date(this.state.detailsData.financialManager.admissionDate+'T00:00:00')}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDate.bind(this, 'financialManager', 'admissionDate')}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
                ) : ('')
              }
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={3} lg={2}>
                <InputMask
                  mask="99.999-999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cep}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.getAddress.bind(this)}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : false}
                >
                  {() => <TextField
                    fullWidth
                    label="CEP"
                    variant="outlined"
                    size="small"
                    name="cep"
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : false}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Logradouro"
                  variant="outlined"
                  size="small"
                  name="addressType"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.addressType}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'addressType')}
                >
                {this.state.addressTypeList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingAddressType === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }

              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={7} className="containerButton">
                <TextField
                  fullWidth
                  label="Endereço"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="address"
                  value={this.state.detailsData.financialManager.address}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'address')}
                />
                {
                  this.state.disabledLoadingAddress === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={1} className="containerButton">
                <TextField
                  id="fm_addressNumber"
                  fullWidth
                  label="Nº"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="addressNumber"
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : false}
                  value={this.state.detailsData.financialManager.addressNumber}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'addressNumber')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                <TextField
                  fullWidth
                  label="Complemento"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="addressComplement"
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true :  false}
                  value={this.state.detailsData.financialManager.addressComplement}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'addressComplement')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={1} lg={1} className="containerButton">
                <TextField
                  fullWidth
                  select
                  label="UF"
                  variant="outlined"
                  size="small"
                  name="state"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.state}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'state')}
                >
                {this.state.stateList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Sigla}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingState === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Município"
                  variant="outlined"
                  size="small"
                  name="city"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.fMCity}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'city')}
                >
                {this.state.cityList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingCity === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Bairro"
                  variant="outlined"
                  size="small"
                  name="district"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.fMDistrict}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'district')}
                >
                {this.state.districtList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingDistrict === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
    );
  }

  beneficiarios() {
    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Titular
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={this.state.detailsData.holder.firstName}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInputHolder}
                  onChange={this.updateFieldHolder.bind(this, 'firstName')}
                  onBlur={this.updateDBHolder.bind(this, 'firstName')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Mãe"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="motherName"
                  value={this.state.detailsData.holder.motherName}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldHolder.bind(this, 'motherName')}
                  onBlur={this.updateDBHolder.bind(this, 'motherName')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  value={this.state.detailsData.holder.cpf}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                >
                  {() => <TextField
                    fullWidth
                    label="CPF"
                    variant="outlined"
                    size="small"
                    name="cpf"
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Data de Nascimento"
                    format="dd/MM/yyyy"
                    size="small"
                    name="dateOfBirth"
                    value={new Date(this.state.detailsData.holder.dateOfBirth+'T00:00:00')}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDate.bind(this, 'holder', 'dateOfBirth')}
                    onClose={this.validateAgeHolder.bind(this)}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  select
                  label="Estado Civil"
                  variant="outlined"
                  size="small"
                  name="maritalStatus"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.holder.maritalStatus}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldHolder.bind(this, 'maritalStatus')}
                  onBlur={this.updateDBHolder.bind(this, 'maritalStatus')}
                >
                  <option value="SOLTEIRO">Solteiro</option>
                  <option value="CASADO">Casado</option>
                  <option value="VIÚVO">Viúvo</option>
                  <option value="SEPARADO">Separado</option>
                  <option value="DIVORCIADO">Divorciado</option>
                  <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="gender"
                  fullWidth
                  select
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  name="gender"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.holder.gender}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldHolder.bind(this, 'gender')}
                  onBlur={this.updateDBHolder.bind(this, 'gender')}
                >
                  <option value="0">Feminino</option>
                  <option value="1">Masculino</option>
                </TextField>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Cartão do SUS"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="susNumber"
                  value={this.state.detailsData.holder.susNumber}
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                  onChange={this.updateFieldHolder.bind(this, 'susNumber')}
                  onBlur={this.updateDBHolder.bind(this, 'susNumber')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <CurrencyTextField
                  label="Valor"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.holder.valuePlan.replace(',', '.')}
                  name="valuePlan"
                  currencySymbol="R$"
                  outputFormat="string"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInputValuePlan}
                  onChange={this.updateCurrencydHolder.bind(this)}
                  onBlur={this.updateDBHolder.bind(this, 'valuePlan', null)}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Dependentes
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
          {
            this.state.detailsData.dependents.length === 0 ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <MuiAlert severity="info" variant="filled" elevation={0}>
                  Sem dependentes cadastrados
                </MuiAlert>
              </Grid>
            </Grid>
            ) : (
              this.state.detailsData.dependents.map((item, index) =>
              <Grid container spacing={2} style={{marginTop: 10}} key={index}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Nome Completo"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="firstName"
                    value={item.firstName}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'firstName', index)}
                    onBlur={this.updateDBDependent.bind(this, 'firstName', index)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <InputMask
                    mask="999.999.999-99"
                    maskChar=" "
                    value={item.cpf}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                  >
                    {() => <TextField
                      fullWidth
                      label="CPF"
                      variant="outlined"
                      size="small"
                      name="cpf"
                      disabled={this.state.detailsData.sales.status === "ATIVO" ? true : true}
                    />}
                  </InputMask>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      label="Data de Nascimento"
                      format="dd/MM/yyyy"
                      size="small"
                      name="dateOfBirth"
                      value={new Date(item.dateOfBirth+'T00:00:00')}
                      disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                      onChange={this.updatedDependentsDate.bind(this, index, 'dateOfBirth')}
                      onClose={this.validateAgeDep.bind(this, index)}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Mãe"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="motherName"
                    value={item.motherName}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'motherName', index)}
                    onBlur={this.updateDBDependent.bind(this, 'motherName', index)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    fullWidth
                    select
                    label="Grau de Perentesco"
                    variant="outlined"
                    size="small"
                    name="parentage"
                    SelectProps={{
                      native: true,
                    }}
                    value={item.parentage}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'parentage', index)}
                    onBlur={this.updateDBDependent.bind(this, 'parentage', index)}
                  >
                    <option value="CÔNJUGE">Cônjuge</option>
                    <option value="FILHO">Filho</option>
                    <option value="PAI/MÃE">Pai/Mãe</option>
                    <option value="ENTEADO">Enteado</option>
                    <option value="OUTRO">Outro</option>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    id="gender"
                    fullWidth
                    select
                    label="Sexo"
                    variant="outlined"
                    size="small"
                    name="gender"
                    SelectProps={{
                      native: true,
                    }}
                    value={item.gender}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'gender', index)}
                    onBlur={this.updateDBDependent.bind(this, 'gender', index)}
                  >
                    <option value="0">Feminino</option>
                    <option value="1">Masculino</option>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    fullWidth
                    select
                    label="Estado Civil"
                    variant="outlined"
                    size="small"
                    name="maritalStatus"
                    SelectProps={{
                      native: true,
                    }}
                    value={item.maritalStatus}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'maritalStatus', index)}
                    onBlur={this.updateDBDependent.bind(this, 'maritalStatus', index)}
                  >
                    <option value="SOLTEIRO">Solteiro</option>
                    <option value="CASADO">Casado</option>
                    <option value="VIÚVO">Viúvo</option>
                    <option value="SEPARADO">Separado</option>
                    <option value="DIVORCIADO">Divorciado</option>
                    <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <TextField
                    fullWidth
                    label="Cartão do SUS"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="susNumber"
                    value={item.susNumber}
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'susNumber', index)}
                    onBlur={this.updateDBDependent.bind(this, 'susNumber', index)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <CurrencyTextField
                    label="Valor"
                    variant="outlined"
                    size="small"
                    value={item.valuePlan.replace(',', '.')}
                    name="valuePlan"
                    currencySymbol="R$"
                    outputFormat="string"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    disabled={this.state.detailsData.sales.status === "ATIVO" ? true : this.state.disabledInputValuePlan}
                    onChange={this.updateCurrencydDependents.bind(this, index)}
                    onBlur={this.updateDBDependent.bind(this, 'valuePlan', index)}
                  />
                </Grid>

                {
                  index + 1 < this.state.detailsData.dependents.length ? (
                <div style={{width: '100%', margin: '15px 0px'}}>
                  <Divider />
                </div>
                  ) : ('')
                }
              </Grid>
              )
            )
          }


          </div>
        </Paper>
      </div>
    );
  }

  documentos() {

    return (
      <div>
        <div className="paper">
          <Grid container spacing={2}>
{/* ################### Imagem RG ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="RG Frente"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg, 'Arquivo do RG')}
                >
                  {
                    this.state.detailsData.imagesDoc.rg.length > 0 ? (
                      this.state.detailsData.imagesDoc.rg.substr(this.state.detailsData.imagesDoc.rg.length - 3, this.state.detailsData.imagesDoc.rg.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="RG Frente"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.rg}
                    title="RG Frente"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.rg.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg, 'Arquivo do RG')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                      this.state.detailsData.sales.status !== "ATIVO" && (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                        )
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem RG (verso) ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="RG Verso"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg2, 'Arquivo do Verso do RG')}
                >
                  {
                    this.state.detailsData.imagesDoc.rg2.length > 0 ? (
                      this.state.detailsData.imagesDoc.rg2.substr(this.state.detailsData.imagesDoc.rg2.length - 3, this.state.detailsData.imagesDoc.rg2.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="RG Verso"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.rg2}
                    title="RG Verso"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.rg2.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg2, 'Arquivo do Verso do RG')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                      this.state.detailsData.sales.status !== "ATIVO" && (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                      )
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem CPF ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="CPF"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cpf, 'Arquivo do CPF')}
                >
                  {
                    this.state.detailsData.imagesDoc.cpf.length > 0 ? (
                      this.state.detailsData.imagesDoc.cpf.substr(this.state.detailsData.imagesDoc.cpf.length - 3, this.state.detailsData.imagesDoc.cpf.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="CPF"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.cpf}
                    title="CPF"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.cpf.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cpf, 'Arquivo do CPF')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                      this.state.detailsData.sales.status !== "ATIVO" && (
                <CardActions>
                   <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                      )
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem Comp. de  Residência ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="Comprovante de Residência"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.resid, 'Arquivo do Comp. de  Residência')}
                >
                  {
                    this.state.detailsData.imagesDoc.resid.length > 0 ? (
                      this.state.detailsData.imagesDoc.resid.substr(this.state.detailsData.imagesDoc.resid.length - 3, this.state.detailsData.imagesDoc.resid.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Comprovante de Residência"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.resid}
                    title="Comprovante de Residência"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.resid.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.resid, 'Arquivo do Comp. de  Residência')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'resid')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                      this.state.detailsData.sales.status !== "ATIVO" && (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'resid')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                      )
                    )
                  }

              </Card>
            </Grid>
{/* ################### Comprovante de Averbação ################### */}
          {
            this.state.showFileAverbation === true && (
              <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="Comprovante de Averbação"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.averbation, 'Arquivo Comprovante de Averbação')}
                >
                  {
                    this.state.detailsData.imagesDoc.averbation.length > 0 ? (
                      this.state.detailsData.imagesDoc.averbation.substr(this.state.detailsData.imagesDoc.averbation.length - 3, this.state.detailsData.imagesDoc.averbation.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Comprovante de Averbação"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.averbation}
                    title="Comprovante de Averbação"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.averbation.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.averbation, 'Arquivo Comprovante de Averbação')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'averbation')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                      this.state.detailsData.sales.status !== "ATIVO" && (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'averbation')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                      )
                    )
                  }

              </Card>
            </Grid>
            )
          }
{/* ################### Imagem Outro ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="Outro"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.others, 'Arquivo Outro')}
                >
                  {
                    this.state.detailsData.imagesDoc.others.length > 0 ? (
                      this.state.detailsData.imagesDoc.others.substr(this.state.detailsData.imagesDoc.others.length - 3, this.state.detailsData.imagesDoc.others.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Outro"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.others}
                    title="Outro"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.others.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.others, 'Arquivo Outro')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                      this.state.detailsData.sales.status !== "ATIVO" && (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                      )
                    )
                  }

              </Card>
            </Grid>
          </Grid>
        </div>


        <DropzoneDialog
          dialogTitle="Upload do arquivo"
          cancelButtonText="CANCELAR"
          submitButtonText="OK"
          getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
          open={this.state.dropzoneDialog}
          onSave={this.fileToBase64.bind(this)}
          acceptedFiles={['image/jpeg', 'image/png', 'image/bmp', 'application/pdf']}
          showPreviews={true}
          maxFileSize={5000000}
          onClose={this.dropzoneDialogClose.bind(this)}
          filesLimit={1}
          dropzoneText="Clique ou arraste e solte um arquivo aqui"
          previewText="Pré-visualização"
          showAlerts={false}
        />
      </div>
    );
  }
  

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="resumoProposta" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  RESUMO DA PROPOSTA{this.state.titlePage}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={8} className="barraBotao">
                <div className="botoesDeEnvio">

                {
                    this.districtToResume() ? (
                      <ReactToPrint                  
                    trigger={() => 
                      <div style={{marginRight: 10}}>
                      
                        <Button 
                          style={{fontSize: 11, backgroundColor: '#636d77', color: '#fff'}}
                          fullWidth={true}
                          variant="contained"
                          size="small"
                          startIcon={<PrintIcon />}
                          color="default"
                          ref={this.printTrigger}
                        
                        >
                          IMPRIMIR
                        </Button>
                      
                      </div>
                    
                    }
                  
                    content={() => this.printContentFinal}
                  
                  />
                      ) : ('')
                    }                  
                  
                </div>

              {
                this.state.showActionCancel === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{fontSize: 11, backgroundColor: "#dc004e", color: "#fff", marginRight: 5}}
                    startIcon={<ClearIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'A proposta ficará como cancelada. Deseja continuar?', 'cancel', 'SIM')}
                  >
                    CANCELAR PROPOSTA
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showActionPendency === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{fontSize: 11, backgroundColor: "#afb42b", color: "#fff", marginRight: 5}}
                    startIcon={<CancelScheduleSendIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'A proposta ficará como indeferida. Deseja continuar?', 'pending', 'SIM')}
                  >
                    INDEFERIR PROPOSTA
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showActionSendAnalyze === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria, marginRight: 5}}
                    startIcon={<SendIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'Confirmo que a proposta está pronta para ser analizada. Deseja continuar?', 'analyze', 'SIM')}
                  >
                    ENVIAR PARA ANÁLISE
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showActionS4 === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    startIcon={<AssignmentTurnedInIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'A proposta será ativada. Deseja continuar?', 'sus', 'SIM')}
                  >
                    ATIVAR PROPOSTA
                  </Button>
                </div>
                ) : ('')
              }
              </Grid>
            </Grid>

          </Paper>

          

          <div id="resumoPropostaConteudo" className="contentepanel">
          {
          this.state.detailsData === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  {this.state.detailsDataLoadingMsg}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.detailsData === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar dados da proposta</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.detailsData === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Esta proposta não foi encontrada</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="resumoPropostaForm">
              <ScrollableTabsButtonAuto contentTabs={
                [
                  this.detalhes(),
                  this.responsavelFinanceiro(),
                  this.beneficiarios(),
                  this.documentos()
                ]
              } />

              <div>
                {/* Página de Impressão */} 

              {                
                this.state.imprimir === true ? (                  

                  <div id="printOnly" ref={el => (this.printContentFinal = el)} style={{display: "none"}}>  

                    <Paper elevation={0} className="paperForm">
                      <div className="paper">

                        <div>
                          < img id="imagemId" alt="logo" src={`${process.env.PUBLIC_URL}/images/logo.png`} />
                        </div>

                        <div>                    
                          <Typography style={{textAlign: 'center', color: configBase.corPrincipal}} variant="h6" gutterBottom className="titlePaperForm">
                            RESUMO DA PROPOSTA Nº {this.state.detailsData.financialManager.proposalNumber}                                         
                          </Typography>                          
                        </div>
                      </div>                     

                      <div>

                        <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                          <Typography
                            variant="overline" gutterBottom className="titlePaperForm"                            
                          >
                            RESPONSÁVEL FINANCEIRO
                          </Typography>
                        </div>

                          <div className="formPrintFields">
                            <Grid container spacing={2} className="respFinanceiro">                                                        
                              <div className="page-break" />                              
                              <Grid item xs={4} sm={4} md={4} lg={3} className="atribRespFinanceiro">                                
                                <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Nome:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" style={{marginBottom: '0px'}}>
                                {this.state.detailsData.financialManager.firstName}    
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>CPF:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.cpf}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={4} lg={3} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>E-mail:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.email}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Tel. Fixo:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                  {this.state.detailsData.financialManager.homePhone}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                                <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Celular:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                  {this.state.detailsData.financialManager.cellPhone}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={4} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>RG:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.rg}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Org. Emissor:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.rgEmitter}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Data de Nascimento:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                  {this.dateOfBirthInverter()}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={4} lg={3} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Mãe:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.motherName}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Estado Civil:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.maritalStatus}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                                <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Sexo:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.gender === 0 ? ("Feminino") : ("Masculino")}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Cartão do SUS:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.susNumber}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>CEP:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.cep}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Logradouro:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.addressTypeName}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Endereço:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.address}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Nº:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.financialManager.addressNumber}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={2} lg={1} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>UF:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.stateToResume()}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Complemento:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                  {this.state.detailsData.financialManager.addressComplement}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Município:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.cityToResume()}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={4} sm={4} md={3} lg={2} className="atribRespFinanceiro">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Bairro:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.districtToResume()}
                                </Typography>
                              </Grid>

                            </Grid>
                          </div>                     

                          <div className="page-break" />
                          <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                            <Typography variant="overline" gutterBottom className="titlePaperForm">
                              Beneficiários
                            </Typography>
                          </div>

                          <div className="formPrintFields">
                            
                            <Grid container spacing={2} className="beneficiarios">
                              <div className="page-break" />
                                <Grid item xs={6} sm={3} md={3} lg={6} className="atribBeneficiarios">
                                  <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                    <strong>Tipo:</strong>
                                  </Typography>
                                  <Typography variant="overline" display="block" gutterBottom>
                                    TITULAR
                                  </Typography>
                                </Grid>

                                <Grid item xs={6} sm={3} md={3} lg={6} className="atribBeneficiarios">
                                  <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                    <strong>Nome:</strong>
                                  </Typography>
                                  <Typography variant="overline" display="block" gutterBottom>
                                    {this.state.detailsData.holder.firstName}
                                  </Typography>
                              </Grid>
                              {
                                this.state.detailsData.dependents !== 0 ? (
                                  
                                  this.state.detailsData.dependents.map((item, index) =>
                                  <Grid key={index} container spacing={2} style={{marginLeft: '0px'}}>
                                     <Grid item xs={6} sm={3} md={3} lg={6} className="atribBeneficiarios">
                                  <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                    <strong>Tipo:</strong>
                                  </Typography>
                                  <Typography variant="overline" display="block" gutterBottom>
                                    DEPENDENTE
                                  </Typography>
                                </Grid>

                                <Grid item xs={6} sm={3} md={3} lg={6} className="atribBeneficiarios">
                                  <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                    <strong>Nome:</strong>
                                  </Typography>
                                  <Typography variant="overline" display="block" gutterBottom>
                                  {item.firstName}
                                  </Typography>
                              </Grid>
                                                                  
                               </Grid>
                          
                                  )
                                  
                                ) : ('')
                              }                             
                               
                            </Grid>
                            

                          </div>

                          <div className="page-break" />
                          <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                          <Typography
                            variant="overline" gutterBottom className="titlePaperForm"                            
                          >
                            Informações do Plano
                          </Typography>
                        </div>

                          <div className="formPrintFields">
                            <Grid container spacing={2} className="infoPlano">
                              <div className="page-break" />
                              <Grid item xs={6} sm={6} md={6} lg={6} className="atribInfoPlano">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Registro:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                  {this.state.detailsData.plan.registro}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={6} sm={6} md={6} lg={6} className="atribInfoPlano">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Plano:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                 {this.state.detailsData.plan.name}
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>

                          <div className="page-break" />
                          <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                            <Typography variant="overline" gutterBottom className="titlePaperForm">
                              Validação
                            </Typography>
                          </div>

                          <div className="formPrintFields">
                          <Grid container spacing={2} className="validacao">
                              <div className="page-break" />
                              <Grid item xs={6} sm={6} md={6} lg={6} className="atribValidacao">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Endereço IP:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                {this.state.detailsData.sales.fMIPConfirm}
                                </Typography>
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={6} sm={6} md={6} lg={6} className="atribValidacao">
                              <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>Data/Hora:</strong>
                                </Typography>
                                <Typography variant="overline" display="block" gutterBottom>
                                {this.formatacaoData()}
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                   
                          <div className="page-break" />
                          <div className="formPrint" style={{fontWeight: 'normal', borderColor: configBase.corPrincipal}}>
                          <Typography
                            variant="overline" gutterBottom className="titlePaperForm"                            
                          >
                            Valor Total
                          </Typography>
                        </div>

                          <div className="formPrintFields">
                            <Grid container spacing={2} className="valorTotal">

                              <div className="page-break" />
                              <Grid item xs={3} sm={6} md={6} lg={3} className="atribValorTotal">                     
                                <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>{this.state.detailsData.dependents.length + 1}X PLANO DENTAL</strong>
                                </Typography>   
                              </Grid>

                              <div className="page-break" />
                              <Grid item xs={9} sm={6} md={6} lg={9} className="atribValorTotal"> 
                                <Typography variant="overline" display="block" gutterBottom style={{textAlign: 'right'}}>                                                 
                                  {this.formatePlanoDental()}
                                </Typography>
                              </Grid>                                          

                              <div className="page-break" />
                              <Grid item xs={3} sm={6} md={3} lg={3} className="atribValorTotal">
                                <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>TAXA DE IMPLEMENTAÇÃO</strong>
                                </Typography>  
                              </Grid>  
                              <div className="page-break" /> 
                              <Grid item xs={9} sm={6} md={6} lg={9} className="atribValorTotal">                         
                              <Typography variant="overline" display="block" gutterBottom style={{textAlign: 'right'}}>                                                 
                                {this.formateTaxaImplementacao()}
                              </Typography>
                              </Grid>                                             
                            
                              <div className="page-break" />
                              <Grid item xs={3} sm={6} md={6} lg={3} className="atribValorTotal">
                                <Typography variant="caption" display="block" gutterBottom style={{color: configBase.corPrincipal}}>
                                  <strong>TOTAL</strong>
                                </Typography>
                              </Grid>
                              <div className="page-break" />
                              <Grid item xs={9} sm={6} md={6} lg={9} className="atribValorTotal">
                                <Typography variant="overline" display="block" gutterBottom style={{textAlign: 'right'}}>                                                 
                                  {this.formateTotal()}
                                </Typography>
                              </Grid>                              
                            </Grid>
                          </div>
                        
                        </div>
                    </Paper>
                  </div>         
                  
                ) : ('')                
              }
              </div>

            </div>
              )
              )
            )
          }
          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.snackbarSuccess} autoHideDuration={5000} onClose={this.snackbarSuccessClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.snackbarSuccessClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSnackbarSuccess}
            </MuiAlert>
          </Snackbar>
        </div>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.modalConfirmOpen}
          onClose={this.handleConfirmClose.bind(this)}
          aria-labelledby="i_modalConfirm"
        >
          <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
          <DialogContent>
            {/* Conteúdo para pergunta */
              this.state.modalConfirmQuestion === true ? (
            <DialogContentText>
              {this.state.modalConfirmQuestionContent}
            </DialogContentText>
              ) : (/* Conteúdo para cancelar */
                this.state.modalConfirmActionType === 'cancel' ? (
            <TextField
              error={this.state.errorRequest}
              fullWidth
              select
              label="Motivo do cancelamento"
              variant="outlined"
              size="small"
              SelectProps={{
                native: true,
              }}
              value={this.state.fieldCancel}
              disabled={this.state.modalConfirmButtonLoading}
              onChange={this.updateFieldCancel.bind(this)}
            >
            <option value="null">Selecione um motivo</option>
            {this.state.cancellationsList.map((item, index) =>
              <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
            )}
            </TextField>
                ) : (/* Conteúdo para pendência */
                  this.state.modalConfirmActionType === 'pending' ? (
            <TextField
              error={this.state.errorRequest}
              fullWidth
              select
              label="Motivo do indeferimento"
              variant="outlined"
              size="small"
              SelectProps={{
                native: true,
              }}
              value={this.state.fieldPending}
              disabled={this.state.modalConfirmButtonLoading}
              onChange={this.updateFieldPending.bind(this)}
            >
              <option value="null">Selecione um motivo</option>
              {this.state.pendencyList.map((item, index) =>
                <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
              )}
            </TextField>
                  ) : (/* Conteúdo ao mandar para análise */
                    this.state.modalConfirmActionType === 'analyze' ? (
                      this.state.detailsData.sales.fMConfirm === null ? (
            <DialogContentText>
              Esta proposta consta como <strong>NÃO CONFIRMADA</strong> pelo responsável financeiro. Ficará aguardando a confirmação do cliente onde a mesma será enviada automaticamente para análise.
            </DialogContentText>
                      ) : (
            <DialogContentText>
              Esta proposta consta como <strong>CONFIRMADA</strong> pelo responsável financeiro e será encaminhada para análise.
            </DialogContentText>
                      ) 
                    ) : (
                      this.state.modalConfirmActionType === 'sus' ? (
            <div>
              {
                this.state.msgSus.length > 0 && (
              <DialogContentText>
                {this.state.msgSus}
              </DialogContentText>
                )
              }

              {
                this.state.msgFileAverbation.length > 0 && (
              <DialogContentText>
                {this.state.msgFileAverbation}
              </DialogContentText>
                )
              }

              {
                this.state.msgContinue && (
              <DialogContentText>
                <br/>
                Deseja continuar?
              </DialogContentText>
                )
              }
            </div>
                      ) : (
                        this.state.modalConfirmActionType === 'activate' ? (
            <div>
              {
                this.state.msgSus.length > 0 && (
              <DialogContentText>
                {this.state.msgSus}
              </DialogContentText>
                )
              }

              {
                this.state.msgFileAverbation.length > 0 && (
              <DialogContentText>
                {this.state.msgFileAverbation}
              </DialogContentText>
                )
              }

              {
                this.state.msgContinue && (
              <DialogContentText>
                <br/>
                Deseja continuar?
              </DialogContentText>
                )
              }
            </div>
                        ) : ('')
                      )
                    )
                  )
                )
              )
            }
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary"
              onClick={this.handleConfirmClose.bind(this)}
            >
              Fechar
            </Button>

            {/* Botão para pergunta */
              this.state.modalConfirmQuestion === true ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.actionsModal.bind(this)}
              >
                {this.state.modalConfirmButton}
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
              ) : (/* Botão para cancelar */
                this.state.modalConfirmActionType === 'cancel' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.actionCancellationsDB.bind(this)}
              >
                CANCELAR PROPOSTA
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                ) : (/* Botão para pendência */
                  this.state.modalConfirmActionType === 'pending' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.actionPendencyDB.bind(this)}
              >
                INDEFERIR PROPOSTA
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                  ) : (/* Botão para mandar para análise */
                    this.state.modalConfirmActionType === 'analyze' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.sendAnalyze.bind(this)}
              >
                {
                  this.state.detailsData.sales.fMConfirm === null ? ("CONFIRMAR") : ("ENVIAR PARA ANÁLISE")
                }
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                    ) : (
                      this.state.modalConfirmActionType === 'activate' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.sendS4.bind(this)}
              >
                ATIVAR
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                      ) : (
                        this.state.modalConfirmActionType === 'sus' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.beforeSendS4.bind(this)}
              >
                ATIVAR
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                        ) : ('')
                      )
                    )
                  )
                )
              )
            }

          </DialogActions>
        </Dialog>
      </MainLayout>
    );

  }

}

ResumoProposta.propTypes = {
  history: PropTypes.object
};

export default withRouter(ResumoProposta);